import { RequestedPartDetail } from "@/lib/queries/types";
import useUpdatePart from "@/lib/queries/useUpdatePart";
import { useEffect, useState } from "react";

export default function QuantityInParent({
  part,
  canEdit,
}: {
  part: RequestedPartDetail;
  canEdit: boolean;
}) {
  const [input, setInput] = useState(part.qty_for_parent);
  useEffect(() => {
    setInput(part.qty_for_parent);
  }, [part]);
  const { updatePart } = useUpdatePart();

  return (
    <div className="relative flex items-center gap-1 h-6">
      <input
        disabled={!canEdit}
        type="number"
        min={1}
        value={input?.toString()}
        onChange={(e) => {
          const newQuantity =
            e.target.value === "" ? 1 : Number(e.target.value);
          setInput(newQuantity);
          updatePart({
            payload: { qty_for_parent: newQuantity },
            partId: part.id,
          });
        }}
        className="field-sizing-content min-w-7 px-1 pr-3 bg-white border border-slate-300 rounded-sm"
      />
      <span className="absolute right-1">×</span>
    </div>
  );
}
